import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "bar-echart" }

import { ref, defineComponent, withDefaults, computed } from 'vue'
import BaseEcharts from '@/Base-UI/echarts/index'
import { IDataType } from '../types/index'
import * as echarts from 'echarts'

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    xLabels: null,
    values: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  xLabels: string[]
  values: any[]
}


/* 柱状图数据 */
const options = computed(() => {
  return {
    title: {
      text: '支持鼠标滚动缩放'
    },
    xAxis: {
      data: props.xLabels,
      axisLabel: {
        inside: true,
        color: '#fff'
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      z: 10
    },
    yAxis: {
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#999'
      }
    },
    dataZoom: [
      {
        type: 'inside'
      }
    ],
    series: [
      {
        type: 'bar',
        showBackground: true,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#83bff6' },
            { offset: 0.5, color: '#188df0' },
            { offset: 1, color: '#188df0' }
          ])
        },
        emphasis: {
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#2378f7' },
              { offset: 0.7, color: '#2378f7' },
              { offset: 1, color: '#83bff6' }
            ])
          }
        },
        data: props.values
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseEcharts), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})